import { DeferObservable } from './DeferObservable';
export var defer = DeferObservable.create;
//# sourceMappingURL=defer.js.map